import React from 'react';

const Header = () => {
    return (
        <header className='container mx-auto px-2 md:py-5 py-2'>
            <div className="-mx-4 flex flex-wrap justify-center">
                <div className="w-full md:px-4">
                    <div className="grid grid-cols-10 pb-2 mb-2 gap-3">
                        <div className="lg:col-span-5 col-span-10 px-4">
                            <span className="text-primary md:mb-2 block text-lg font-bold font-inter">
                                Latest Projects
                            </span>
                            <h2
                                className="text-dark md:mb-4 text-2xl font-bold font-poppins sm:text-4xl md:text-[40px]"
                            >
                                My Recent Projects
                            </h2>
                            <p className="font-inter text-gray-500 font- text-base">
                                {/* Note:  is a website design and development agency at Naxos Greek, Where I’m working as a web designer and developer.
                                    <br className='hidden sm:block' /> */}
                                It’s not just a image, All website build my own and live.
                            </p>
                        </div>
                        <div className="hidden lg:block lg:col-span-5 col-span-10 px-4">
                            -
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;